import { NgModule } from '@angular/core';
import { AiAssistantFabComponent } from './components/ai-assistant-fab/ai-assistant-fab.component';

/**
 * Global AI Chat Assistant (Leads v1). Re-exports the standalone {@link AiAssistantFabComponent}
 * so the app shell can mount a single `<app-ai-assistant-fab>` in `full.component.html`.
 * The FAB lazily hosts the slide-out panel and all child components.
 *
 * Docs: docs/AI-ASSISTANT-LEADS-PLAN.md, docs/ai-assistant-api.md.
 */
@NgModule({
  imports: [AiAssistantFabComponent],
  exports: [AiAssistantFabComponent],
})
export class AiAssistantModule {}
